import React from "react";
import {
  Button,
  Segment,
  Text,
  Provider,
} from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import ImageTitleContainer from "../ImageTitleContainer";
import SecureLoginImage from "../../../assets/images/undraw_secure_login_pdn4.svg";
import Constants from "../../../constants/text-constants";
import PasswordTextInput from "../../atoms/PasswordTextInput";
import { observer } from "mobx-react-lite";
import { useMst } from "../../../hooks/useMst";

const ForgottenPasswordEnterPasswordStep = observer((props) => {
  const {
    gotoSignIn,
    newPWErrorMessage,
    confirmPWErrorMessage,
    id,
    valid,
    loading,
    onSubmit,
    handleValueChange,
  } = props;

  const { passwordHintStore } = useMst();

  const onChange = (event) => {
    if (handleValueChange) {
      handleValueChange(event.target.id, event.target.value);
    }
  };

  const onChangePassword = () => {
    onSubmit();
  };

  const getErrorContent = (errorMessage) => {
    const showNewPWErrorMessage = errorMessage === null ? false : true;

    return showNewPWErrorMessage
      ? {
          error: showNewPWErrorMessage,
          content: errorMessage === "" ? undefined : errorMessage,
        }
      : null;
  };

  const bgClass = "reset-password-step segment";

  return (
    <Provider.Consumer
      render={(theme) => (
        <Segment
          className={
            theme.siteVariables.themeString === "dark"
              ? bgClass + " dark"
              : bgClass
          }
          data-testid="forgottenPasswordEnterPasswordContainer"
        >
          <ImageTitleContainer
            image={SecureLoginImage}
            title={Constants.RESET_PASSWORD}
            subTitle={Constants.USE_PASSWORD_TO_SIGN_IN_FROM_NOW_ON}
            testId={"resetPasswordHeader"}
          >
            <PasswordTextInput
              id={id + "Password"}
              maxLength="128"
              fluid
              label={Constants.NEW_PASSWORD}
              data-testid={"resetNewPasswordInput"}
              onChange={onChange}
              error={getErrorContent(newPWErrorMessage)}
              errorMessage={getErrorContent(newPWErrorMessage)}
              disabled={loading}
            />
            <PasswordTextInput
              id={id + "PasswordConfirm"}
              maxLength="128"
              fluid
              label={Constants.CONFIRM_NEW_PASSWORD}
              data-testid={"resetConfirmPasswordInput"}
              onChange={onChange}
              error={getErrorContent(confirmPWErrorMessage)}
              errorMessage={getErrorContent(confirmPWErrorMessage)}
              disabled={loading}
            />
            <Text content={passwordHintStore.passwordHintsText} />
            <Button
              data-testid={"resetBtn"}
              primary
              content={Constants.RESET_PASSWORD_BUTTON}
              onClick={onChangePassword}
              disabled={!valid || loading}
              loading={loading}
            />
            <Button
              text
              content={Constants.BACK_TO_SIGN_IN}
              data-testid={"backBtn"}
              onClick={gotoSignIn}
              disabled={loading}
            />
          </ImageTitleContainer>
        </Segment>
      )}
    ></Provider.Consumer>
  );
});

ForgottenPasswordEnterPasswordStep.propTypes = {
  gotoSignIn: PropTypes.func,
  newPWErrorMessage: PropTypes.string,
  confirmPWErrorMessage: PropTypes.string,
  id: PropTypes.string,
  valid: PropTypes.bool,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  handleValueChange: PropTypes.func,
};

ForgottenPasswordEnterPasswordStep.defaultProps = {
  confirmPWErrorMessage: "",
  id: "",
  valid: false,
  loading: false,
};

export default ForgottenPasswordEnterPasswordStep;
